import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environment/environment';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private baseUrl = `${environment.baseUrl}/api/v1/`;

  private dataLoaded = false;

  constructor(private http: HttpClient, private router: Router) {}

  postRequest(endpoint: string, data: any): Observable<any> {
    const options = {
      withCredentials: true,
    };
    return this.http.post(this.baseUrl + endpoint, data, options);
  }

  getParamRequest(endpoint: string, params: any): Observable<any> {
    const options = {
      params: params,
      withCredentials: true
    };
    return this.http.get(this.baseUrl + endpoint, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  clearData(): void {
    this.dataLoaded = false;
    sessionStorage.clear();
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem('treeData');
    this.router.navigate(['/login']);
  }

  putRequest(endpoint: string, data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.put(this.baseUrl + endpoint, data, { headers: headers })
      .pipe(
        catchError(error => {
          console.error('Error in putRequest:', error);
          throw error;
        })
      );
  }

  getRequest(endpoint: string): Observable<any> {
    return this.http.get(this.baseUrl + endpoint)
  }

  deleteRequest(endpoint: string): Observable<any> {
    return this.http.delete(this.baseUrl + endpoint)
  }

  isAuthenticated(): boolean {
    const token = sessionStorage.getItem('access_token');
    if (!token) {
      return false;
    }
  
    const tokenExpiry = this.decodeTokenExpiry(token);
    
    if (tokenExpiry < Date.now()) {
      this.clearData();
      return false;
    }

    return true;
  }

  private decodeTokenExpiry(token: string): number {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000;
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Unknown error!';

    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
